import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../models/models';
import { UserService } from '../user.service';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  userId: number;

  private _authNavStatusSource = new BehaviorSubject<User>({
    id: 0,
    organization: '',
    department: '',
    division: '',
    organizationId: 0,
    departmentId: 0,
    divisionId: 0,
    fullName: '',
    blocked: false,
    checked: false,
    position: '',
    isAuthor: false,
    isCoAuthor: false,
    isRealizer: false,
    blockId: 0,
    block: '',
  });
  authLoggedIn$ = this._authNavStatusSource.asObservable();

  constructor(
    private authService: AuthService,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /* При переносе всего функционала в новый проект необходимо перевести авторизацию на JwtToken */
    return this.userService.get().pipe(map((res: User) => {
      /* Данная проверка дополнительная. Основная проверка осуществляется в контроллере. */
      if (res && res.id && res.id > 0 && !res.blocked) {
        this.userId = res.id;
        this._authNavStatusSource.next(res);
        return true;
      }
      else {
        this.authService.redirectToAuthorizeUrl();
        return false;
      }
    }));
  }
}
